import {getMaxValuesOnFitPageProperty, getMaxValuesOnPageProperty} from '../ChartPDFDefinitionPartsConstructors'

export default class BaseCreateDefinitionObjectStrategy {
    constructor(chartType) {
        this.chartType = chartType
    }

    createDocDefinitionObject(
        ddBuilder,
        pagesData,
        pdfPrintParameters,
        includeOtherUsers,
    ) {
        const adjustedPagesData = this.adjustDataParameters(pagesData, pdfPrintParameters)

        const dd = ddBuilder.createNewDocDefinitionWithFooter()

        const needToShowTable = this._needToShowTable(pdfPrintParameters)
        for (let pageIndex = 0; pageIndex < adjustedPagesData.length; pageIndex++) {
            let isFirstPage = (pageIndex === 0)
            const currentPage = adjustedPagesData[pageIndex]
            if (!isFirstPage) {
                ddBuilder.addPageBreaker(dd)
            }
            if (isFirstPage || pdfPrintParameters.showHeaderOnEachPage) {
                ddBuilder.addHeader(dd, pdfPrintParameters.showLogoInHeader, includeOtherUsers)
            }
            if (needToShowTable) {
                this.addPageDataWithDataList(ddBuilder, dd, currentPage, pdfPrintParameters, pageIndex)
            } else {
                this.addPageDataWithoutDataList(ddBuilder, dd, currentPage, pdfPrintParameters, adjustedPagesData.length)
            }
        }
        return dd
    };

    _needToShowTable(pdfPrintParameters) {
        return pdfPrintParameters.showListOfDataValues || pdfPrintParameters.showListOfPercentValues
    }

    /**
     * if need to adjust parameters for parameters specific
     * @param pagesData - original data
     * @param pdfPrintParameters - pdf display parameters
     */
    adjustDataParameters(pagesData, pdfPrintParameters) {
        // abstract
    }

    /**
     * Add page to doc definition if need to show data list
     * @param ddBuilder - doc definition builder
     * @param docDefinition - current doc definition
     * @param pageData - current page data (image + data list)
     * @param pdfPrintParameters - pdf display parameters
     * @param pageIndex - index of current page
     */
    addPageDataWithDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, pageIndex) {
        // abstract
    }

    /**
     * Add page to doc definition if no need show data list
     * @param ddBuilder - doc definition builder
     * @param docDefinition - current doc definition
     * @param pageData - current page data (only image(es))
     * @param pdfPrintParameters - current parameters
     * @param nPages - n rendered pages
     */
    addPageDataWithoutDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, nPages) {
        // abstract
    }

    getMaxValuesOnPage({paperOrientation, paperSize, showHeaderOnEachPage}) {
        return getMaxValuesOnPageProperty({
            paperOrientation,
            paperSize,
            chartType: this.chartType,
        })
    }

    getMaxValuesOnPageWithoutTable({paperOrientation, paperSize, showHeaderOnEachPage}) {
        return 2 * this.getMaxValuesOnPage({paperOrientation, paperSize, showHeaderOnEachPage})
    }

    getMaxValuesOnFitPage({paperOrientation, paperSize, showHeaderOnEachPage}) {
        return getMaxValuesOnFitPageProperty({
            paperOrientation,
            paperSize,
            chartType: this.chartType,
        })
    }

    getTotalNumberOfPages(lengthOfDataList, pdfPrintParameters) {
        // abstract
    }

    getChartImageDimensions(lengthOfDataList, pdfPrintParameters) {
        // abstract
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/doStrategy/BaseCreateDefinitionObjectStrategy.js